import script from "./comStoreBizSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./comStoreBizSelect.vue?vue&type=script&setup=true&lang=js"

import "./comStoreBizSelect.vue?vue&type=style&index=0&id=6741ac4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6741ac4d"]])

export default __exports__